

























































































import Vue from "vue";
import { SharedState } from "@/common/state";

import { ref, Ref } from "@vue/composition-api";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { PopulationTypeHelper, POPULATION_TYPE } from "@/common/models";
import { ICONS } from "@/common/icons.map";
import {
  apps_as_list,
  entity_to_restriction,
  info_type_code_to_restriction,
} from "@/common/models/admin-restrictions.model";
export default Vue.extend({
  components: { AppCheckbox },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  setup(props, { emit }) {
    const info_types: Ref<any[]> = ref(
      SharedState.l0InfoTypes.value
        .filter((f) => f.id !== SharedState.default_label_id.value)
        .map((l0) => {
          return {
            id: info_type_code_to_restriction[l0.code],
            code: l0.code,
            order: l0.l0Order,
            name: l0.labelName,
          };
        })
        .sort((a: any, b: any) => a.order - b.order)
    );
    const entities: Ref<any[]> = ref(
      [
        POPULATION_TYPE.EVENT,
        POPULATION_TYPE.FOLDER,
        POPULATION_TYPE.ORGANIZATION,
        POPULATION_TYPE.EMPLOYEE,
        POPULATION_TYPE.CONTACT,
      ].map((type) => {
        return {
          name: PopulationTypeHelper.asString(type, true),
          icon: ICONS.ENTITIES.get(type),
          id: entity_to_restriction[type],
        };
      })
    );

    const apps = ref(apps_as_list());

    const toggle_val = (restriction: string) => {
      // @ts-ignore;
      const current: string[] = [...props.value];
      const index = current.indexOf(restriction);
      if (index > -1) {
        current.splice(index, 1, "");
        emit(
          "input",
          current.filter((l) => l)
        );
      } else {
        emit("input", [...current, restriction]);
      }
    };

    return {
      info_types,
      entities,
      toggle_val,
      apps,
    };
  },
});
